module.exports = __webpack_public_path__ + "img/eye.39cd0e05.svg";